import React, { useState, useContext } from "react";
import { MdPerson, MdExpandMore } from "react-icons/md";

import DropdownUser from './DropdownListUser'
import {AuthContext} from '../services/Session/Context'

const UserInfos = () => {
  const { user } = useContext(AuthContext)
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className='justify-end hidden md:flex'>
        <MdPerson className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
        <button
          className="ml-3 flex items-center text-gray-500 dark:text-white text-md"
          onClick={() => setOpen(!open)}
        >
          {user.firstName} {user.lastName.charAt(0)} <MdExpandMore className="ml-2" />
        </button>
      </div>
      { open && <DropdownUser />}
    </>
  );
}

export default UserInfos